/**
 * Poster component.
 */
import Colors from '@shared/assets/style/default/color';
import DeviceConfig from '@devices/config';
import PosterDefault from '@shared/assets/images/png/posterDefault.png';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

/**
 * Props interface for poster component.
 */
interface Props {
  height: number;
  width: number;
  src: string;
}

/**
 * Styled image component for poster.
 */
const Poster = styled.img<Props>`
  background: ${Colors['background']};
  border-radius: ${20 * Screen.widthRatio}px;
  border: 1px solid #707070;
  object-fit: ${() =>
    DeviceConfig.capabilities.image.disableFitCover ? 'unset' : 'cover'};
  position: absolute;
  height: ${(props) => props.height * Screen.widthRatio}px;
  width: ${(props) => props.width * Screen.widthRatio}px;
`;

Poster.defaultProps = {
  width: 230,
  height: 350,
  src: PosterDefault,
};

export default withImage(Poster, true, PosterDefault);
